import { cn } from "@/ui/cn";

import { DIET_DISPLAY, type DietType } from "./dish-display";

/** The square food mark (dot in a square), with its name for screen readers. */
export function DietMark({ diet, className }: { diet: DietType; className?: string }) {
  const display = DIET_DISPLAY[diet];
  return (
    <span
      role="img"
      aria-label={display.label}
      title={display.label}
      className={cn(
        "flex size-4 shrink-0 items-center justify-center rounded-[3px] border-2",
        display.ring,
        className,
      )}
    >
      <span className={cn("size-1.5 rounded-full", display.dot)} />
    </span>
  );
}
